export enum PrePayNoticeCode {
    /**
     * 寻合作禁止预充值
     */
    findCooper = 'FORBIDDEN_PRE_CHARGE',
    /**
     * 免费版本禁止预充值
     */
    freeVersion = 'FORBIDDEN_PRE_CHARGE_FREE_CONTRACT',
    /**
     *  风险中间商标签
     */
    RISK_MIDDLE_COMPANY = 'RISK_MIDDLE_COMPANY',
}

export interface ModalContentType {
    /**
     * 禁止预充值Code
     */
    code: PrePayNoticeCode
}

/** 是否免费版本禁止预充值 */
export const getIsFreeVersionPreCharge = (code: PrePayNoticeCode) => code === PrePayNoticeCode.freeVersion
